import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

export default function Reviewer() {
  return (
    <div className='font-mono'>
      <Accordion sx={{width: "37rem"}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <p className='flex justify-center items-center'> <p><PersonSearchIcon /></p>  <p className='font-bold'>Reviewer</p>  </p>
        </AccordionSummary>
        <AccordionDetails>
        <div className="bg-slate-50 p-4 applcnt-pro-bioData-inner-con rounded-lg">
        
        <ul>
            <li><b>Scholarship Amount:</b> <span> N250,000</span></li>
            <li><b>Current Level:</b> <span>200 Level</span></li>
            <li><b>Course Duration:</b> <span>4 Years</span></li>
            <li><b>Status:</b> <span> Still Studying </span></li>
            <li><b>CGPA:</b> <span> 4.7 </span></li>
            <li><b>Reviewer's Comment:</b> <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam ipsa officia incidunt facilis illo ad iusto aliquid, molestias repellat similique totam suscipit velit</span></li>

        </ul>

      </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}